export const content = {
  zeitraum: 'Zeitraum',
  sapId: 'SAP-ID (E)',
  experte: 'Trainer:in',
  experten: 'Trainer:innen',
  akaVeranstaltungId: 'AKA-Veranstaltung-ID',
  wo: 'Wo?',
  terminart: 'Terminart',
  geschaeftsbereich: 'Geschäftsbereich',
  manuellerAusschreibungsprozess: 'Manueller Ausschreibungsprozess',
};
